export default __webpack_public_path__ + "static/media/img-5.cf278977.png";